import { render, staticRenderFns } from "./modelUpload.vue?vue&type=template&id=3f8b2e24&scoped=true"
import script from "./modelUpload.vue?vue&type=script&lang=js"
export * from "./modelUpload.vue?vue&type=script&lang=js"
import style0 from "./modelUpload.vue?vue&type=style&index=0&id=3f8b2e24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f8b2e24",
  null
  
)

export default component.exports